// Date 2021-01-04 16:47:07

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";

import repairPlanDetailEdit from "@/views/em/repair/RepairPlanDetailEdit.vue";
import repairPlanDetailList from "@/views/em/repair/RepairPlanDetailList.vue";
import repairPlanList from "@/views/em/repair/RepairPlanList.vue";
import repairPlanEdit from "@/views/em/repair/RepairPlanEdit.vue";
import repairPlanTask from "@/views/em/repair/RepairPlanTask.vue";
import repairWorkOrderEdit from "@/views/em/repair/RepairWorkOrderEdit.vue";
import repairWorkOrderList from "@/views/em/repair/RepairWorkOrderList.vue";
import repairSppOrderEdit from "@/views/em/repair/RepairSppOrderEdit";
import repairSppOrderTask from "@/views/em/repair/RepairSppOrderTask";
import repairSppOrderList from "@/views/em/repair/RepairSppOrderList";
import repairWorkOrderTask from "@/views/em/repair/RepairWorkOrderTask.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/repair/repairConstructionUnit/list",
        name: "repairConstructionUnitList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairConstructionUnit/edit",
        name: "repairConstructionUnitEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/repair/repairSpecializedType/list",
        name: "repairSpecializedTypeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairSpecializedType/edit",
        name: "repairSpecializedTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/repair/repairEventLevel/list",
        name: "repairEventLevelList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairEventLevel/edit",
        name: "repairEventLevelEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/repair/repairOrigin/list",
        name: "repairOriginList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairOrigin/edit",
        name: "repairOriginEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/repair/repairPlanCategory/list",
        name: "repairPlanCategoryList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairPlanCategory/edit",
        name: "repairPlanCategoryEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/repair/repairPriority/list",
        name: "repairPriorityList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairPriority/edit",
        name: "repairPriorityEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/em/repair/repairPlanDetailEdit",
        name: "repairPlanDetailEdit",
        component: repairPlanDetailEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairPlanDetailList",
        name: "repairPlanDetailList",
        component: repairPlanDetailList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairPlanList",
        name: "repairPlanList",
        component: repairPlanList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairPlanEdit",
        name: "repairPlanEdit",
        component: repairPlanEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairPlanTask",
        name: "repairPlanTask",
        component: repairPlanTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairWorkOrderTask",
        name: "repairWorkOrderTask",
        //component: emWorkflowTaskView,
        component: repairWorkOrderTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairWorkOrderEdit",
        name: "repairWorkOrderEdit",
        component: repairWorkOrderEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairWorkOrderList",
        name: "repairWorkOrderList",
        component: repairWorkOrderList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairSppOrderEdit",
        name: "repairSppOrderEdit",
        component: repairSppOrderEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairSppOrderTask",
        name: "repairSppOrderTask",
        component: repairSppOrderTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/repair/repairSppOrderList",
        name: "repairSppOrderList",
        component: repairSppOrderList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]